"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tertiary = exports.secondary = exports.primary = void 0;
var _styledComponents = require("styled-components");
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var primary = (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n"], ["\n    color: ", ";\n    background-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.grey[0];
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.white;
});
exports.primary = primary;
var secondary = (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n"], ["\n    color: ", ";\n    background-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.grey[1];
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.grey[5];
});
exports.secondary = secondary;
var tertiary = (0, _styledComponents.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n"], ["\n    color: ", ";\n    background-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.white;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.grey[0];
});
exports.tertiary = tertiary;
var templateObject_1, templateObject_2, templateObject_3;